import React from 'react';

interface SearchComponentProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  icon?: boolean;
}

const SearchComponent: React.FC<SearchComponentProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
  icon = true,
}) => {
  return (
    <div className={`relative ${className}`}>
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg
              className="h-4 w-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        )}
        <input
          type="text"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full min-w-[300px] ${icon ? 'pl-10' : 'pl-3'} pr-3 py-2 text-sm 
                     bg-white dark:bg-secondary-dark 
                     border border-gray-300 dark:border-gray-600 rounded-lg
                     text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400
                     hover:border-gray-400 dark:hover:border-gray-500
                     focus:outline-none focus:ring-1 focus:ring-gray-300/30 dark:focus:ring-gray-400/30
                     focus:border-gray-400 dark:focus:border-gray-500
                     transition-colors duration-200`}
        />
      </div>
    </div>
  );
};

export default SearchComponent; 